<template>
  <div>
    <video class="banner" autoplay loop muted playsinline>
      <source class="banner-video" src="@/assets/pasajero.mp4" type="video/mp4">
      Tu navegador no soporta el elemento de video.
    </video>

  </div>
</template>

<script>

export default {
  name: "SliderComp",

  data() {
    return {};
  },

  created: function () {
    //$(".carousel").carousel();
  },

  methods: {
    verPromo: function () {
      alert("VER PROMO");
    },
  },
};
</script>

<style scoped>
* {
  font-family: "Poppins", sans-serif;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.slider {
  /*z-index: 1;*/
  /* position: relative; */
  background: #097948;
  width: 100%;
  min-height: 600px;
  /*
    width: 800px;
    min-height: 500px;
    margin: 10px;*/
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: hidden;
  border-radius: 10px;
  /*margin-bottom: 20px;*/
}

.banner {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  height: 700px;

  width: 100%;
  object-fit: cover;
  /* Ajusta el tamaño del video como fondo */
  z-index: -1;
  /* Envía el video al fondo */
  color: white;
  font-weight: 700;


}


.promo {
  text-align: left;
  margin-bottom: 40%;
}

.slider .slide {
  /*z-index: 1;*/
  position: absolute;
  width: 100%;
  height: 100%;
  clip-path: circle(0% at 0 50%);
}

.slider .slide.active {
  clip-path: circle(150% at 0 50%);
  transition: 2s;
}

.slider .slide img {
  /*z-index: 1;*/
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.carousel-inner .carousel-item .info {
  position: absolute;
  color: #004d27;
  background: rgba(255, 255, 255, 0.3);
  width: 75%;
  margin-top: 50px;
  margin-left: 50px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 5px 25px rgb(1, 1, 1 / 5%);
}

.slider .slide .info {
  position: absolute;
  color: #004d27;
  background: rgba(255, 255, 255, 0.3);
  width: 75%;
  margin-top: 50px;
  margin-left: 50px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 5px 25px rgb(1, 1, 1 / 5%);
}

.carousel-inner .carousel-item .info h2 {
  font-size: 2em;
  font-weight: 800;
}

.slider .slide .info h2 {
  font-size: 2em;
  font-weight: 800;
}

.carousel-inner .carousel-item .info p {
  font-size: 1em;
  font-weight: 400;
}

.slider .slide .info p {
  font-size: 1em;
  font-weight: 400;
}

.navigation {
  height: 500px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 0;
  transition: opacity 0.5s ease;
}

.slider:hover .navigation {
  opacity: 1;
}

.slide .carousel-item .carousel-inner .carousel-float {
  z-index: 999;
}

.prev-btn,
.next-btn {
  z-index: 2;
  font-size: 2em;
  color: rgba(255, 255, 255, 0.8);
  padding: 10px;
  cursor: pointer;
}

.prev-btn {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
}

.next-btn {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}

.navigation-visibility {
  z-index: 2;
  display: flex;
  justify-content: center;
}

.navigation-visibility .slide-icon {
  z-index: 2;
  background: rgba(255, 255, 255, 0.5);
  width: 10px;
  height: 10px;
  transform: translate(-50px);
  margin: 0 15px;
  border-radius: 2px;
  box-shadow: 0 5px 25px rgb(1, 1, 1 / 20%);
}

.navigation-visibility .slide-icon.active {
  background: #004d27;
}

@media (max-width: 900px) {
  .slider {
    width: 100%;
  }

  /*EDIT*/

  .slider .slide .info {
    position: relative;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
  }
}

@media (max-width: 500px) {
  .slider .slide .info h2 {
    font-size: 1.8em;
    line-height: 40px;
  }

  .slider .slide .info p {
    font-size: 0.9em;
  }

  .slider {
    height: 50%;
  }

  /*EDIT*/
}
</style>
